// API Configuration
const config = {
  development: {
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
    TIMEOUT: 30000,
    WITH_CREDENTIALS: false,
    ENVIRONMENT: 'development',
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL || 'https://kaozyaschools.ac.tz/backend_api.php/',
    TIMEOUT: 30000,
    WITH_CREDENTIALS: false,
    ENVIRONMENT: 'production',
  }
};

const environment = process.env.REACT_APP_ENVIRONMENT || 'production';
export default config[environment];
